import { render, staticRenderFns } from "./ThreeEchart.vue?vue&type=template&id=08560aff&scoped=true"
import script from "./ThreeEchart.vue?vue&type=script&lang=js"
export * from "./ThreeEchart.vue?vue&type=script&lang=js"
import style0 from "./ThreeEchart.vue?vue&type=style&index=0&id=08560aff&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08560aff",
  null
  
)

export default component.exports